<template>
  <VaLayout v-if="breakpoint.lgUp" class="h-screen bg-[var(--va-background-secondary)]">
    <template #left>
      <div
        class="bg-color h-full flex items-center justify-center"
        style="width: 35vw; background: linear-gradient(180deg, #2a1f31 16.1%, #6d2e21 100.81%) !important"
      >
        <div>
          <!-- <RouterLink to="/" aria-label="Visit homepage"> -->
          <NetcoreLogo :height="28" :width="400" />
          <!-- </RouterLink> -->
          <!-- <div class="text-center va-h3" style="color: white">Velocity</div> -->
        </div>
      </div>
    </template>
    <template #content>
      <main class="h-full flex items-center justify-center mx-auto max-w-[420px]">
        <RouterView />
      </main>
    </template>
  </VaLayout>

  <!-- <VaLayout v-if="breakpoint.lgUp" class="h-screen bg-[var(--va-background-secondary)]">
    <template #content>
      <div class="p-4">
        <main class="h-full flex flex-row items-center justify-start mx-auto max-w-[420px]">
          <div class="flex flex-col items-start">
            <RouterLink class="py-4" to="/" aria-label="Visit homepage">
              <NetcoreLogo class="mb-2" />
            </RouterLink>
            <RouterView />
          </div>
        </main>
      </div>
    </template>
  </VaLayout> -->
  <div
    v-if="!breakpoint.lgUp"
    class="bg-color h-full flex items-center justify-center h-screen"
    style="width: 100vw; background: linear-gradient(180deg, #2a1f31 16.1%, #6d2e21 100.81%) !important"
  >
    <div>
      <NetcoreLogo :height="28" :width="400" />
      <div class="mt-16 py-4 rounded-xl px-4 bg-white border">
        <h1 class="text-center text-xl">Switch to desktop</h1>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useBreakpoint } from 'vuestic-ui'
import NetcoreLogo from '../components/NetcoreLogo.vue'
// import Footer from '@/components/Footer.vue'
const breakpoint = useBreakpoint()
</script>
<style scoped>
.bg-color {
  background-color: linear-gradient(180deg, rgba(224, 138, 250, 1) 0%, rgba(190, 82, 242, 1) 100%) !important;
}
.desktop-display {
  display: block;
}
.mobile-display {
  display: none;
  height: 100vh;
}

@media (max-width: 1100px) {
  /* Your CSS rules go here */
  .mobile-display {
    display: block;
    height: 100vh;
  }
  .desktop-display {
    display: none;
  }
}
</style>
